import { Modal, Radio, DatePicker, Button, message } from "antd";
import React, { useCallback, useContext, useMemo, useState } from "react";
const { RangePicker } = DatePicker;
import zhCN from "antd/es/date-picker/locale/zh_CN";
import styles from "./modal.module.less";
import { syncConfirmNew } from "@/utils/syncConfirm";
import ImService from "@/server/ImService";
import dayjs from "dayjs";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import { UserState } from "@/models/user";
import { getClientType } from "@/utils";
import { ClientType } from "@/types/chat";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { isSameDay } from "@/utils/date";

const SelectTimes = [
  {
    label: "今天",
    value: 1
  },
  {
    label: "最近7天",
    value: 7
  },
  {
    label: "最近30天",
    value: 30
  },
  {
    label: "全部",
    value: -1
  }
];
function RecordCleanModal(props: any) {
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const { modalVisible, handleClickClose, selectedSession, userData } = props;
  const [selectTime, setSelectTime] = useState(0);
  const [rangeKey, setRangeKey] = useState<any>(new Date().getTime());
  const [params, setParams] = useState<any>(null);

  const cleanData = useCallback(() => {
    setSelectTime(0);
    setRangeKey(new Date().getTime());
    setParams(null);
  }, []);

  const doClickClose = useCallback(() => {
    cleanData();
    handleClickClose();
  }, [handleClickClose, cleanData]);

  const onSelectChange = useCallback((val: any) => {
    const { value } = val;
    const d = new Date();
    setSelectTime(value);
    switch (value) {
      case 1:
        setParams({
          beginTime: dayjs(d).hour(0).minute(0).second(0).valueOf(),
          endTime: d.getTime()
        });
        break;
      case -1:
        setParams({
          beginTime: 0,
          endTime: d.getTime()
        });
        break;
      default:
        setParams({
          beginTime: dayjs(d).add(-value, "day").hour(0).minute(0).second(0).valueOf(),
          endTime: d.getTime()
        });
        break;
    }
  }, []);

  // 选择日期
  const handleDateChange = useCallback((val: any) => {
    if (!val) {
      setParams({});
    } else {
      // 非当天23.59.59
      const endTime = isSameDay(new Date().getTime(), val[1].valueOf())
        ? dayjs(val[1]).valueOf()
        : dayjs(val[1]).hour(23).minute(59).second(59).valueOf();
      setSelectTime(0);
      setParams({
        beginTime: dayjs(val[0]).hour(0).minute(0).second(0).valueOf(),
        endTime
      });
    }
  }, []);

  // 禁用时间
  const disabledDate = (current: any) => {
    // Can not select days before today and today
    return current && current > dayjs().endOf("day");
  };

  const rangePickerContent = useMemo(() => {
    return (
      <RangePicker
        className={styles["date-wrap"]}
        locale={zhCN}
        placeholder={["开始日期", "结束日期"]}
        onChange={(dates: any) => handleDateChange(dates)}
        key={rangeKey}
        disabledDate={disabledDate}
      />
    );
  }, [handleDateChange, rangeKey]);

  const handleClean = useCallback(async () => {
    const confirm = await syncConfirmNew(
      "操作后，全部群成员所有端的消息记录将被擦除",
      "是否擦除消息记录",
      {
        className: "task-common-modal-lb warn-tip"
      }
    );
    if (confirm) {
      try {
        await ImService.getInstance()?.sendCleanMessage({
          groupId: selectedSession?.sessionId,
          deviceId: userData?.app?.deviceId,
          clientType: getClientType() === "MAC" ? ClientType.MAC : ClientType.PC,
          ...params
        });
      } catch(e) {
        message.error("操作失败");
      }
      doClickClose();
    }
  }, [
    appRuntimeEnv?.registryConfig.machineId,
    doClickClose,
    params,
    selectedSession.sessionId,
    userData.app.client,
    userData.app.deviceId
  ]);

  const hasTimes = useMemo(() => {
    return !!params?.endTime;
  }, [params]);

  const modalFooter = useMemo(() => {
    return (
      <div className={styles["footer"]}>
        <Button onClick={doClickClose}>取消</Button>
        <Button type="primary" danger onClick={handleClean} disabled={!hasTimes}>
          擦除
        </Button>
      </div>
    );
  }, [handleClean, doClickClose, hasTimes]);
  return (
    <Modal
      className={styles["clean-modal-wrap"]}
      title="擦除消息记录"
      width="560px"
      maskStyle={{
        opacity: "0.5"
      }}
      mask={false}
      destroyOnClose={true}
      closable={false}
      onCancel={doClickClose}
      zIndex={199}
      footer={modalFooter}
      visible={modalVisible}
    >
      <div className={styles["tip-content"]}>
        <span className={styles["text"]}>
          请谨慎！操作后，全部组成员所有端指定时间的消息记录将被擦除
        </span>
      </div>
      <div className={styles["select-wrap"]}>
        <span className={styles["title"]}>请设定擦除时间范围</span>
        <Radio.Group
          onChange={(e) => onSelectChange(e?.target)}
          value={selectTime}
          className={styles["radio-group"]}
        >
          {SelectTimes.map((item, idx) => {
            return (
              <Radio key={`selectItem_${idx}`} value={item.value}>
                {item.label}
              </Radio>
            );
          })}
        </Radio.Group>
        {rangePickerContent}
      </div>
    </Modal>
  );
}

function mapStateToProps({ chat, user }: { chat: ChatState, user: UserState }) {
  return {
    selectedSession: chat.selectedSession,
    userData: user.userData
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(RecordCleanModal);
